import script from "./FAQ.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQ.vue?vue&type=script&setup=true&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=5c4dd36b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c4dd36b"]])

export default __exports__